import { BoxProps } from '../BoxNew'
import { TextProps } from '../TextNew'

const defaultStyles = {
  text: (isPressed: boolean) =>
    ({
      color: isPressed ? 'BRAND_PRIMARY_WHITE_CLICKED' : 'BRAND_PRIMARY_WHITE',
      type: 'body14',
    } as TextProps),
  container: {
    justifyContent: 'center',
    alignItems: 'center',
    backgroundColor: 'BRAND_PRIMARY_ACTION',
    hoverColor: 'BG_PRIMARY_BUTTON_HOVER',
    underlayColor: 'BG_PRIMARY_BUTTON_CLICKED',
  } as BoxProps,
  disabledOpacity: 0.5,
}

const bigButtonDim = {
  maxWidth: '328px',
  height: '48px',
}

const smallButtonDim = {
  height: '32px',
}

const customButtonDim = {
  height: '32px',
}

const tertiaryButtonDim = {
  height: '32px',
}

const secondaryStyle = {
  borderRadius: 'MEDIUM',
  shadowType: 'shadowPrimary',
  underlayColor: 'BG_SECONDARY_BUTTON_CLICKED',
  hoverColor: 'BG_SECONDARY_BUTTON_HOVER',
  borderColor: 'BRAND_PRIMARY_ACTION',
  borderWidth: 1,
  backgroundColor: 'BRAND_PRIMARY_WHITE',
}

const buttonTypes = {
  primary: {
    ...defaultStyles,
    container: {
      ...defaultStyles.container,
      ...bigButtonDim,
      borderRadius: 'MEDIUM',
      shadowType: 'shadowPrimary',
    } as BoxProps,
    buttonContainer: {},
  },
  primaryIcon: {
    ...defaultStyles,
    container: {
      ...defaultStyles.container,
      ...bigButtonDim,
      borderRadius: 'MEDIUM',
      shadowType: 'shadowPrimary',
    } as BoxProps,
    buttonContainer: {},
  },
  primarySmall: {
    ...defaultStyles,
    container: {
      ...defaultStyles.container,
      type: 'fullFlexJustifyAlignCenter',
      borderRadius: 'MEDIUM',
      shadowType: 'shadowPrimary',
    } as BoxProps,
    buttonContainer: {
      ...smallButtonDim,
      paddingVertical: 'MEDIUM',
    } as BoxProps,
  },
  primaryIconSmall: {
    ...defaultStyles,
    container: {
      ...defaultStyles.container,
      type: 'fullFlexJustifyAlignCenter',
      borderRadius: 'MEDIUM',
      shadowType: 'shadowPrimary',
    } as BoxProps,
    buttonContainer: {
      ...smallButtonDim,
      paddingVertical: 'MEDIUM',
    } as BoxProps,
  },
  primaryFullWidth: {
    ...defaultStyles,
    container: {
      ...defaultStyles.container,
      ...customButtonDim,
      borderRadius: 'MEDIUM',
      shadowType: 'shadowPrimary',
    } as BoxProps,
    buttonContainer: {},
  },
  secondary: {
    ...defaultStyles,
    container: {
      ...defaultStyles.container,
      ...bigButtonDim,
      ...secondaryStyle,
    } as BoxProps,
    buttonContainer: {},
    text: (isPressed: boolean) =>
      ({
        ...defaultStyles.text(isPressed),
        color: 'BRAND_PRIMARY_ACTION',
      } as TextProps),
  },
  secondaryFullWidth: {
    ...defaultStyles,
    container: {
      ...defaultStyles.container,
      ...customButtonDim,
      ...secondaryStyle,
    } as BoxProps,
    buttonContainer: {},
    text: (isPressed: boolean) =>
      ({
        ...defaultStyles.text(isPressed),
        color: 'BRAND_PRIMARY_ACTION',
      } as TextProps),
  },
  secondaryIcon: {
    ...defaultStyles,
    container: {
      ...defaultStyles.container,
      ...bigButtonDim,
      ...secondaryStyle,
    } as BoxProps,
    buttonContainer: {},
    text: (isPressed: boolean) =>
      ({
        ...defaultStyles.text(isPressed),
        color: 'BRAND_PRIMARY_ACTION',
      } as TextProps),
  },
  secondarySmall: {
    ...defaultStyles,
    container: {
      ...defaultStyles.container,
      type: 'fullFlexJustifyAlignCenter',
      ...secondaryStyle,
    } as BoxProps,
    buttonContainer: {
      ...smallButtonDim,
      paddingVertical: 'MEDIUM',
    } as BoxProps,
    text: (isPressed: boolean) =>
      ({
        ...defaultStyles.text(isPressed),
        color: 'BRAND_PRIMARY_ACTION',
      } as TextProps),
  },
  secondaryIconSmall: {
    ...defaultStyles,
    container: {
      ...defaultStyles.container,
      type: 'fullFlexJustifyAlignCenter',
      ...secondaryStyle,
    } as BoxProps,
    buttonContainer: {
      ...smallButtonDim,
      paddingVertical: 'MEDIUM',
    } as BoxProps,
    text: (isPressed: boolean) =>
      ({
        ...defaultStyles.text(isPressed),
        color: 'BRAND_PRIMARY_ACTION',
      } as TextProps),
  },
  tertiary: {
    ...defaultStyles,
    container: {
      ...defaultStyles.container,
      ...tertiaryButtonDim,
      hoverColor: 'BG_TERTIARY_HOVER',
      underlayColor: 'BG_TERTIARY_CLICKED',
      backgroundColor: 'BRAND_THEME',
    } as BoxProps,
    buttonContainer: {},
    text: (isPressed: boolean) =>
      ({
        ...defaultStyles.text(isPressed),
        color: 'BRAND_PRIMARY_ACTION',
      } as TextProps),
  },
  tertiaryIcon: {
    ...defaultStyles,
    container: {
      ...defaultStyles.container,
      ...tertiaryButtonDim,
      hoverColor: 'BG_TERTIARY_HOVER',
      underlayColor: 'BG_TERTIARY_CLICKED',
      backgroundColor: 'BRAND_THEME',
    } as BoxProps,
    buttonContainer: {},
    text: (isPressed: boolean) =>
      ({
        ...defaultStyles.text(isPressed),
        color: 'BRAND_PRIMARY_ACTION',
      } as TextProps),
  },
  custom: {
    ...defaultStyles,
    container: {
      ...defaultStyles.container,
      ...customButtonDim,
      borderRadius: 'MEDIUM',
      shadowType: 'shadowPrimary',
      shadowColor: 'GRAY_SHADOW',
    } as BoxProps,
    buttonContainer: {},
  },
  textWithIcon: {
    disabledOpacity: 0.5,
    container: {
      justifyContent: 'center',
      alignItems: 'center',
      hoverColor: 'TRANSPARENT',
      underlayColor: 'TRANSPARENT',
      backgroundColor: 'TRANSPARENT',
      height: 12,
      paddingLeft: 0,
    } as BoxProps,
    buttonContainer: {},
    text: (isPressed: boolean) =>
      ({
        color: isPressed ? 'BRAND_COLOR_GRAY_3' : 'PRIMARY',
        type: 'body14',
      } as TextProps),
  },
  materialRed: {
    ...defaultStyles,
    disabledOpacity: 1,
    container: {
      ...defaultStyles.container,
      borderRadius: 'MEDIUM',
      shadowType: 'shadowPrimary',
      shadowColor: 'GRAY_SHADOW',
      backgroundColor: 'PRIMARY',
      hoverColor: 'PRIMARY',
    } as BoxProps,
    buttonContainer: {},
    text: (isPressed: boolean) =>
      ({
        color: isPressed ? 'WHITE' : 'BRAND_PRIMARY_WHITE',
        type: 'body14',
        fontWeight: '500',
      } as TextProps),
  },
}

export { buttonTypes }
